const messages = {
    fields: {
        first_name: 'Nome',
        last_name: 'Cognome',
        address: 'Indirizzo',
        postcode: 'Codice Postale',
        city: 'Cittá',
        phone: 'Numero di telefono',
        house_number: 'numero',
        password: 'Wachtwoord',
    },
    customPages: {
        mainCategory: 'categorie principali',
    },
    validations: {
        required: "{field} e' richiesto",
        invalid: '{field} non corretto',
    },
    blockCart: {
        addToCart: 'Aggiungi al carrello',
        addedToCartTitle: 'Aggiunto al tuo carrello',
        continueShopping: 'Continua lo shopping',
        proceedToCheckout: 'Carrello',
        productTotal: 'Totale',
        showAllProducts: 'Mostra tutti i prodotti',
        cartShipping: 'Costi di spedizione',
        cartTotal: 'Totale',
        close: "Data dell'ordine",
        addedToCartChoiceTitle: 'La tua scelta:',
        noItemSelected: 'Non hai selezionato una variante!',
        frequentlyBoughtTogether: 'Spesso acquistati insieme'
    },
    myAccount: {
        titlePersonalInformation: 'I miei dati',
        adjustData: 'Modifica dati',
        setNewPassword: 'Nuova password?',
        phoneNumberMessage: "L'autista della consegna potrebbe contattarti",
        houseNumber: 'Nr',
        optional: 'Opzionale',
        currentPassword: 'Password corrente',
        newPassword: 'Nuova password',
        email: 'E-mail',
        titleOrderHistory: 'I miei ordini',
        logout: 'Esci',
        loading: 'Sto caricando...',
        yourCart: 'Il tuo carrello',
        address2: 'Ulteriori informazioni sull´indirizzo',
        addAddress: 'Aggiungi indirizzo',
        defaultAddress: 'Indirizzo standard',
        setAsDefaultAddress: 'fare standard',
        adjust: 'Modifica',
        name: 'Nome',
        firstName: 'Nome',
        lastName: 'Cognome',
        address: 'Indirizzo',
        zipcode: 'Codice Postale',
        residence: 'Città',
        country: 'Nazione',
        phone: 'Telefono',
        phoneNumber: 'Numero di telefono',
        copyAddress: "Copia l'indirizzo",
        delete: 'Cancella',
        errorMessage: 'Errore riscontrato',
        cancel: 'Annulla',
        save: 'Salva',
        packaging: 'Imballaggio',
        unitPrice: 'Prezzo unitario',
        price: 'prezzo',
        totalPriceProducts: "Prezzo totale dell'ordine",
        total: 'Totale',
        freeOfCharge: 'Gratis',
        taxIncl: 'IVA inclusa',
        continueToOrder: 'Procedi al pagamento',
        easyReorder: "E'semplice riordinare!",
        easyReorderMessage: 'Metti nel carrello i prodotti degli scorsi ordini e procedi al pagamento.',
        emtpyOrderMessage:
            'Qui ritrovi il tuo ordine effettuato con le informazioni sui tempi di consegna, la tua fattura, etc. Da questa pagina puoi anche facilmente ripetere gli ordini precedenti.',
        emtpyOrderMessage2: 'Clicca',
        emtpyOrderMessage3: 'qui',
        emtpyOrderMessage4: ' per tornare a Casa.',
        reorder: 'Riordina',
        products: 'Prodotti',
        totalShipmentCost: 'Costi totali di spedizione',
        shipmentCost: 'costi di spedizione',
        status: "Stato dell'ordine",
        detailsInvoice: 'Dettagli e fattura',
        downloadInvoice: 'Scarica la fattura',
        shippedBy: 'Spedito da',
        paymentMethod: 'Modalità di pagamento',
        deleteAddressModalText: 'Sei sicuro di voler cancellare questo indirizzo?',
        deleteAddressModalLoaderText: 'Cancellazione in corso',
        errorModalText: 'Ci scusiamo, errore nella transazione',
        errorModalText2: 'Prova di nuovo più tardi',
        appModalTitle: 'Brekz - Negozio online per animali domestici - App',
        appModalText:
            'Op elk moment alles voor uw huisdier kunnen bestellen? Vanaf nu kunt u dit gemakkelijk doen via de Brekz App.\n' +
            'Duizenden producten zoals voer, lekkere snacks en leuke speeltjes op één plek gemakkelijk bestellen.',
        appModalText2: 'Puoi trovare il nostro App nel Play Store o App Store',
        appModalListTitle: 'Vantaggi',
        appModalListItem: '- Il tuo negozio online sempre a portata di mano',
        appModalListItem1: ' - Riordini facili e veloci',
        appModalListItem2: '- Pratiche notifiche e aggiornamenti suoi tuoi ordini e',
        appModalListItem3: '- Imposta quali  / quante notifiche vuoi ricevere',
        appModalListItemLink: 'Offerte speciali',
        reorderModalSorry: ' Purtroppo non disponibile ',
        reorderModalOutOfStock: 'Non disponibile',
        reorderModalPackaging: 'Questo prodotto non è più disponibile',
        reorderModalSkip: 'Salta questo prodotto',
        reorderModalAlternativesInStock: 'Prodotti alternativi disponibili ',
        reorderModalQuantity: ' Quantità ',
        pricePerUnit: ' Prezzo unitario ',
        addProduct: ' Aggiungi al carrello ',
        bundleDiscount: 'Risparmio su set',
        discount: 'Risparmio',
        reorderModalOrderAlternative: 'Ordine alternativo',
        saveConfirmationModalTitle: 'I vostri dati sono stati salvati',
        minimumPurchaseMessage:
            'Per poter acquistare la spesa minima dev’essere di {amount} (costi di spedizione esclusi) aggiungere uno o più prodotti al vostro carrello per continuare.',
        trackAndTraceText: "Traccia il tuo ordine (disponibile dopo l'invio del pacco)",
        noAlternativeProducts: 'Purtroppo non offriamo nessun altro formato.',
        addressDescription: 'Qui trovi un riepilogo dei tuoi dati. Puoi anche modificarli qui.\n',
        titleMyOrders: 'I miei ordini',
        orderDescription: 'Controlla lo stato del tuo ordine, della tua fattura o riordina\n',
        orderDescriptionShort: 'Controlla lo stato del tuo ordine\n',
        addresses: 'I miei indirizzi',
        okay: 'Ok',
        errorFirstName: 'Compila correttamente il nome di battesimo',
        errorLastName: 'Compila correttamente il cognome',
        errorEmail: "Compila correttamente l'indirizzo e-mail",
        errorPhone: 'Controlla il numero di telefono',
        errorAddress: 'Controlla indirizzo e numero civico',
        errorAddress2: 'Controlla indirizzo e numero civico',
        errorZipcode: 'Codice postale errato',
        errorCity: 'Controlla la citt̀',
        errorPassword: 'Password mancante o troppo corta',
        eraseWarning: 'Stai per cancellare tutti i dati che hai inserito!',
        eraseConfirmation: 'Sei sicuro?',
        amount: 'Quantità',
        orderDate: "Data dell'ordine",
        trackAndTrace: 'Track & Trace',
        close: 'Chiudi',
        toCart: 'Al carrello',
        productsInCart: 'I prodotti sono stati aggiunti al carrello',
        orderInCart: 'Il tuo ordine è stato aggiunto al carrello.',
        productsInColumn:
            "Puoi trovarli nella colonna di destra di questa pagina, oppure clicca sull'icona del carrello in alto a destra",
        orderStatus: 'Stato del tuo ordine',
        orderProcess: 'Nella maggior parte dei casi, il tuo ordine passa attraverso le seguenti fasi:',
        paymentWaiting: 'In attesa del pagamento',
        paymentReceived: 'Ricevere il pagamento',
        orderCollected: "L'ordine è in fase di raccolta",
        orderSent: 'Il tuo ordine è stato spedito',
        followOrder: 'Ora puoi rintracciare il tuo pacchetto tramite ',
        followOrderEnd: '.',
        multiplePackages: "N.B.: l'ordine contiene più pacchetti",
        trackAndTraceActiveTime: "NB: potrebbe essere necessario un po' di tempo prima che il link diventi attivo",
        delivered: 'Ordine consegnato',
        password: 'Password',
        didYouMean: 'Intendeva',
        apply: 'Applicare',
        bundle: 'Set',
        bundlePriceWas: 'Originale',
        saving: 'Risparmio',
    },
    checkout: {
        between: '',
        and: ' - ',
        days: "giorni lavorativi",
        delivery: 'Consegna',
        countdownMessage1: 'Ordina entro',
        countdownMessage2: 'per una consegna più rapida',
        newCard: 'Usa una nuova carta di credito',
        creditCard: 'Carta di credito',
        addNewCard: 'Inserisci nuova {card}',
        passwordMessage: 'Minimo 5 caratteri',
        loading: 'Sto caricando...',
        lastStep: 'Ultimo passo',
        savedCard: 'Usa la carta salvata',
        cardNumber: 'Numero della carta',
        otherCard: "Usa un'altra carta",
        expireDate: 'Data di scadenza',
        errorCard: 'Questa carta non è valida o non è autorizzata',
        errorName: 'Nome non valido',
        errorDate: 'Data di scadenza non valida o carta scaduta',
        errorCVV: 'CVV corrente non valido',
        cardExpired: 'Quella carta è scaduta nel nostro sistema. La preghiamo di registrare nuovamente la sua carta.',
        saveCard: 'Salva Carta di credito',
        nextTime: 'per il prossimo acquisto',
        order: 'Ordina',
        back: 'Torna alle opzioni di pagamento',
        addressEdit: 'Modifica indirizzo attuale',
        paymentSucces: 'Pagamento ricevuto correttamente',
        backToOrderhistory: 'Tra pochi secondi verrai ridiretto alla pagina del tuo ordine',
        bancontactNotAvailable: 'Il contatto con la tua banca non é disponibile',
        allData: 'Tutti i tuoi dati personali sono',
        secured: 'protetti',
        almostDone: 'Quasi finito',
        banContactNotAvailable: 'Bancontact is niet beschiktbaar op',
        payWith: 'Reken af met uw',
        bancontactApp: 'Bancontact app',
        useOtherBancontact: 'Andere Bancontact gebruiken',
        useNewBancontact: 'Nieuwe Bancontact gebruiken',
        addNewBancontact: 'Nieuwe Bancontact toevoegen',
        payWithBancontactApp: 'Betaal met de bancontact App',
        openBancontactApp: 'Open de bancontact app en scan de code om de betaling met de app af te ronden',
        noBancontactApp: 'Heeft u de app niet? Gebruik dan de methode hiernaast.',
        mistercacheSave: 'Bancontact opslaan',
        cardHolderNamePlaceholder: 'C. ROSSI',
        newAccount: 'I tuoi dati personali',
        cancel: 'Annulla',
        taxIncl: 'IVA inclusa',
        total: 'Totale',
        name: 'Nome',
        close: 'Sluiten',
        errorText: 'Ci scusiamo, errore nella transazione',
        errorModalText: 'Ci scusiamo, errore nella transazione',
        errorModalText2: 'Prova di nuovo più tardi',
        rememberAddressHeaderTitle: 'Risparmia tempo nel tuo prossimo ordine',
        rememberAddressSwitchLabel: 'Usa questo inidirizzo e questo metodo di pagamento per il prossimo ordine',
        paymentSecurityText: 'Tutti i vostri dati sono',
        paymentSecurityTextBold: 'protetti',
        paymentCardHeaderTitle: 'Opzioni di pagamento',
        addressCardHeaderTitle: 'Indirizzo di consegna',
        invoiceAddress: 'Indirizzo della fattura',
        editAddress: 'Regolare',
        addNewAddress: 'Inserisci un nuovo indirizzo',
        addNewInvoiceAddress: 'Aggiungere un nuovo indirizzo di fatturazione',
        addressMatchesInvoiceAddress: "L'indirizzo della fattura è uguale all'indirizzo di consegna",
        addressMatchesNotInvoiceAddress: "L'indirizzo della fattura non è uguale all'indirizzo di consegna",
        // checkout progressbar
        progressbarLogIn: 'Accedi a',
        progressbarPaymentOption: 'Opzione di pagamento',
        progressbarPayment: 'Pagamento',
        progressbarDone: 'Pronti!',
        klarnaPhoneNumberRequiredModal: {
            modalMessage:
                'Hai scelto il pagamento posticipato tramite Klarna. Per questo è necessario il tuo numero telefonico.',
            phoneNumberInputField: 'Inserisci qui il tuo numero telefonico',
            otherPaymentMethod: 'Other payment method',
        },
        validationErrors: {
            noPaymentMethodSelected: 'Non hai ancora scelto un metodo di pagamento',
            noAddressSelected: 'Non hai ancora scelto un indirizzo di consegna e/o di fattura',
            paymentMethodRequiresPhoneNumber:
                'Manca il numero telefonico nel tuo indirizzo. Ti preghiamo di aggiungerlo per poter pagare con Klarna.',
            termsOfServices: 'U heeft de Algemene voorwaarden niet geaccepteerd',
            noDeliveryOnThisAddress:
                "Purtroppo non effettuiamo consegne nel codice postale indicato. Al momento dell'ordine, è possibile scegliere di far recapitare il pacco a un codice postale diverso.",
        },
        processWaiting: {
            title: 'Quasi finito',
            description: 'Il tuo pagamento È in corso',
        },
    },
    address: {
        placeholderFirstname: 'Jan',
        placeholderLastname: 'Janssen',
        placeholderAddress: 'Piazza del Colosseo',
        placeholderAddress2: 'azienda , edificio, appartamento , piano di abitazione ect',
        placeholderZipcode: '12345',
        placeholderCity: 'Roma',
        placeholderPhone: '0612345678',
        noShipping:
            'In base al codice postale scelto, purtroppo si applicano costi di spedizione aggiuntivi. Per evitare questi costi, potete far recapitare il pacco ad un altro codice postale.',
    },
    outOfStockNotificationOptin: {
        modalTitle: 'Vi prego di tenermi informato',
        modalMessage: "Riceverai un'e-mail appena questo prodotto sar̀ di nuovo disponibile.",
        modalSubmitButton: 'Vi prego di tenermi informato',
        email: 'E-mail',
        placeholderEmail: 'anteprima@email.com',
        noAbuse: 'Il vostro indirizzo e-mail non sar̀ utilizzato per altri scopi.',
        alreadySignedUp: 'Hai gì richiesto di ricevere un avviso via mail per questo prodotto.',
        invalidEmail: 'E-mail non valida',
        genericError: 'Qualcosa è andata storta',
    },
    orderConfirmation: {
        modalTitle: 'Vuoi essere in grado di rintracciare il tuo ordine?',
        modalMessage:
            'Hai ordinato come ospite. Se aggiungi una password, puoi seguire il tuo ordine nel riepilogo degli ordini del tuo account personale.',
        enterPassword: 'Aggiungi una password',
        minimumWarning: 'Almeno 5 caratteri',
        passwordTooShort: 'La password inserita è troppo corta',
        somethingWentWrong: 'Si è verificato un errore generale',
    },
    unsubPage: {
        emailQuestion: 'Per quale indirizzo e-mail?',
        emailKnown: 'Indirizzo e-mail del tuo account: ',
        emailadres: 'Indirizzo e-mail:',
        changeEmailSettings: 'Cambiare le impostazioni della posta elettronica ',
        iWant: 'Voglio',
        iWant2: 'Ik wil',
        keepProfiting: 'continuare a beneficiare ',
        ofTheBenefitMail: 'delle email promozionali',
        sendMe: 'Inviatemi',
        onesEvery2Weeks: 'offerte esclusive e i migliori sconti ',
        exclusiveOffersAndTheBestDiscounts: 'una volta ogni due settimane',
        onetimeAMonth: 'Una volta al mese ',
        wellEnoughButDontMiss: 'è sufficiente, ma non voglio perdere nessuna offerta',
        noBenefit: 'Niente più offerte per me',
        writeMeOut: ", mi cancello dall'iscrizione ",
        benefitMail: 'Posta con offerte',
        birthdayMail: 'Posta di compleanno',
        tipsAndAdvice: 'Suggerimenti e consigli',
        personalDiscount: 'Sconti personalizzati ',
        productReviewAndReviews: 'Valutazione del prodotto e recensioni',
        stillReceiveUpdatesAboutDelivery:
            'Naturalmente continuerai a ricevere aggiornamenti sui tuoi ordini e consegne ',
        feedBackAndTips: 'Hai qualche consiglio o feedback per noi?',
        cancel: 'Cancella',
        benefitDogCat: 'Vuoi ricevere offerte per cane o gatto?',
        iWantBenefitFor: 'Vorrei ricevere le offerte per',
        dogs: 'Cane',
        cats: 'Gatto',
        dogsAncCats: 'Cane e Gatto',
        no: 'Non voglio più ',
        receiveMoreBenefitFor: 'ricevere offerte per',
        giveMe: 'Voglio',
        allBenefit: 'tutte le offerte ',
        average2MailsAWeek: '(media di 2 mail con offerte speciali a settimana)',
        oneTime2Weeks: '1 volta alla settimana',
        save: 'Salva',
        received: '',
        selectVariant: 'Scegliere la variante',
        YouAreSuccessfullyUnsubscribedFor: "Hai annullato con successo l' iscrizione  a:",
        checkYourEmail: 'Controlla il tuo indirizzo email',
        noOptionSelected: 'Non hai selezionato alcuna opzione',
    },
    algoliaSearch: {
        mqc: {
            max: 'Max',
            perCustomer: 'per cliente',
        },
        searchButton: 'Cerca',
        searchPlaceholder: 'Cerca il prodotto',
        searchBarInputPlaceholder: 'Cerca il prodotto',
        searchBarInputPlaceholderApp: '6000+ prodotti',
        noResultsContentTitleCategory: 'Purtroppo non sono stati trovati prodotti con i filtri selezionati.',
        noResultsContentTitle:
            'Non abbiamo <b>trovato risultati</b> per <span class="algolia-listing-no-results__content-title--brand">“{query}“</span>',
        noResultsContentListTitle: 'Cosa puoi fare:',
        noResultsContentListItemOne: 'Controlla',
        noResultsContentListItemOneCategory: 'Rimuovere uno o più filtri',
        noResultsContentListItemTwo:
            'Stavi cercando il nome di una marca? Purtroppo non abbiamo (ancora) questo marca nel nostro assortimento.',
        noResultsContentListItemTwoCategory: 'Fare clic su "Cancella tutto" per avviare una nuova selezione.',
        noResultsContentListItemThree: 'Prova una ricerca diversa',
        noResultsWithQuery: 'Nessun suggerimento trovato per <b>"{query}"</b>',
        searchHistoryTitle: 'Prodotti visti di recente',
        searchResultsHeader: '<b>{resultCount}</b> resultaten voor <b>"{query}"</b> in alle artikelen.',
        searchResultsHeaderSubtitle: 'Verfijn uw resultaten met onderstaande filters.',
        searchResultsTitle: 'Suggerimenti di ricerca',
        popularProductsTitle: 'I prodotti più ricercati',
        popularCategoriesTitle: 'Categorie più richieste',
        queryMirrorTitle: 'La vostra ricerca',
        resultsHitsProducts: 'Prodotti',
        resultsHitsDelete: 'Cancella tutto',
        resultsHitsFilter: 'Filtra',
        resultsHitsFilterNote: 'Usa I filtri per trovare più velocemente',
        fiterPanelMobileHeaderTitle: 'Filtra',
        fiterPanelMobileHeaderSubtext: 'Usa I filtri per trovare più velocemente',
        fiterPanelMobileDeleteFilters: 'Cancella tutto',
        fiterPanelMobileFilteredProductAmount: 'Prodotti',
        fiterPanelMobileSaveSelection: 'Salva la selezione',
        fiterPanelMobileFooterTextPartOne: 'Filtra',
        fiterPanelMobileFooterTextPartTwo: 'risultati',
        hitItemFromLabel: 'a partire da',
        hitItemViewProduct: 'Vai al prodotto',
        refinementListViewMore: 'Altre opzioni...',
        refinementListViewLess: 'altro...',
        refinementListRangeBoxInbetween: '>',
        unAvailableNotePartOne: 'a',
        unAvailableNotePartTwo: 'di nuovamente disponibile',
        filters: {
            priceReduction: {
                on: 'Si',
                off: 'No',
            },
        },
    },
    algoliaRecommend: {
        recommendedProducts: 'Prodotti simili',
        recommendedProductsSubtitle: 'Diversi, ma anche al top!',
        boughtTogether: 'Spesso acquistati insieme',
        boughtTogetherSubtitle: 'Pronti in un colpo solo!'
    },
    mobileMenu: {
        makeYourChoice: 'Fai la tua scelta',
    },
    combinationPromotion: {
        op: 'Ultimi prodotti',
        bonus: 'Bonusbag',
        twoPlusOneFree: '2 + 1 Gratuito',
        minusTenPercent: '-10%',
        minusTwentyPercent: '-20%',
        minusTwentyFivePercent: '-25%',
        minusThirtyPercent: '-30%',
        minusFortyPercent: '-40%',
        minusFiftyPercent: '-50%',
        minusSixtyPercent: '-60%',
        minusSeventyPercent: '-70%',
    },
    resetPassword: {
        passwordError: 'Le password non corrispondono',
        passwordForgot: 'Hai dimenticato la password?',
        createNewPassword: 'Crea una nuova password',
        description:
            "Inserisci l'indirizzo e-mail del tuo account. Invieremo un link a questo indirizzo e-mail che ti consentir̀ di impostare una nuova password.",
        email: 'Inirizzo e-mail',
        note: "Può essere necessario un po' di tempo per ricevere il link. Attendi almeno 4 minuti prima di richiedere un nuovo link per evitare di ricevere un link non funzionante.",
        setNewPassword: 'Imposta una nuova password',
        chooseNewPassword: 'Scegli una nuova password',
        newPassword: 'Nouveau mot de passe',
        reenterPassword: 'Inserisci ancora la tua nuova password',
        passwordsDontMatch: 'La password nel campo 2 non è uguale al campo 1',
        passwordsDontMatchError: 'Le password non corrispondono',
        submit: 'Invia',
    },
};
export default messages;
